// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"08281a85","404":"5d72362d"}[chunkId] + ".chunk.js";
};